import { render, staticRenderFns } from "./ChangeList.vue?vue&type=template&id=42d4ebab&scoped=true&"
import script from "./ChangeList.vue?vue&type=script&lang=js&"
export * from "./ChangeList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeList.vue?vue&type=style&index=0&id=42d4ebab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4ebab",
  null
  
)

export default component.exports